import React from 'react';

const ForgotPassword = ({history}) => {
    return(
        <>
            <div className="login-form">
                <div className="text-center mb-10 mb-lg-20">
                    <h3 className="font-size-h1">Forgotten Password ?</h3>
                    <p className="text-muted font-weight-bold">Enter your email to reset your password</p>
                </div>
                <div className="form-group">
                    <input className="form-control form-control-solid h-auto py-5 px-6" type="email" placeholder="Email" name="email" autoComplete="off" />
                </div>
                <div className="form-group d-flex flex-wrap flex-center">
                    <button type="button" id="kt_login_forgot_submit" className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4">Submit</button>
                    <button type="button" id="kt_login_forgot_cancel" className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4">Cancel</button>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;